<ng-container>
  <div class="section-header">
    <span>Company name</span>
  </div>
  <div class="section-wrapper">
    <div nz-row class="section-row section-row--dashed" *ngIf="natureOfBusiness?.investmentBusinessActivityType">
      <div nz-col nzSpan="11" class="section-label">
        Type of business activity
      </div>
      <div nz-col nzSpan="13">
        <span class="tag">
          {{ investmentBusinessActivityText }}
        </span>
      </div>
    </div>

    <div nz-row *ngIf="isRco()" class="section-row section-row--dashed">
      <div nz-col nzSpan="11" class="section-label">
        Which form of Recognised Company you want to establish in
      </div>
      <div nz-col nzSpan="13">
        <span class="tag">
          {{recognizedFormText}}
        </span>
      </div>
    </div>

    <div nz-row class="section-row section-row--dashed">
      <div nz-col nzSpan="11" class="section-label">
        Name of a legal entity to be established in the AIFC
      </div>
      <div nz-col nzSpan="13">
        <span class="section-value">
          {{fullName || '-'}}
        </span>
      </div>
    </div>

    <div nz-row class="section-row section-row--dashed">
      <div nz-col nzSpan="11" class="section-label">
        Abbreviated Name (En)
      </div>
      <div nz-col nzSpan="13">
        <span class="section-value">
          {{fullAbbrName || '-'}}
        </span>
      </div>
    </div>


    <nz-collapse [nzBordered]="false" class="sections-collapse">
      <nz-collapse-panel nzHeader="Other languages">
        <div nz-row class="section-row">
          <div nz-col nzSpan="11" class="section-label">
            Proposed name in Russian
          </div>
          <div nz-col nzSpan="13">
            <span class="section-value">
              {{fullNameRu || '-'}}
            </span>
          </div>
        </div>

        <div nz-row class="section-row">
          <div nz-col nzSpan="11" class="section-label">
            Abbreviated Name (RU)
          </div>
          <div nz-col nzSpan="13">
            <span class="section-value">
              {{fullAbbrNameRu || '-'}}
            </span>
          </div>
        </div>

        <div nz-row class="section-row">
          <div nz-col nzSpan="11" class="section-label">
            Proposed name in Kazakh
          </div>
          <div nz-col nzSpan="13">
            <span class="section-value">
              {{fullNameKz || '-'}}
            </span>
          </div>
        </div>

        <div nz-row class="section-row">
          <div nz-col nzSpan="11" class="section-label">
            Abbreviated Name (KZ)
          </div>
          <div nz-col nzSpan="13">
            <span class="section-value">
              {{fullAbbrNameKz || '-'}}
            </span>
          </div>
        </div>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
</ng-container>

<ng-container>
  <div class="section-header">
    <span>Business Activity</span>
  </div>
  <div class="section-wrapper">
    <div nz-row class="section-row section-row--dashed">
      <div nz-col nzSpan="11" class="section-label">
        Business activity type
      </div>
      <div nz-col nzSpan="13">
        <span class="section-value">
          {{getBusinessActivityTypeTitle()}}
        </span>
      </div>
    </div>

    <div nz-row class="section-row section-row--dashed" *ngIf="isInvestCompany()">
      <div nz-col nzSpan="11" class="section-label">
        Business activities
      </div>
      <div nz-col nzSpan="13">
        <div class="activities-list">
          <div class="activity-item"
              *ngFor="let item of natureOfBusiness?.businessActivities">
            {{ item.activityDescription }}
          </div>
        </div>
      </div>
    </div>


    <div nz-row class="section-row">
      <div nz-col nzSpan="11" class="section-label">
        Detailed description of your business activities to be conducted in the AIFC
      </div>
      <div nz-col nzSpan="13">
        <span class="section-value">
          {{natureOfBusiness?.businessActivityDescription}}
        </span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container>
  <div class="section-header">
    <span>Business Activity Codes</span>
  </div>
  <div class="section-wrapper">
    <div nz-row class="section-row section-row--dashed">
      <div nz-col nzSpan="11" class="section-label">
        Main
      </div>
      <div nz-col nzSpan="13">
        <div class="activity-code">
          <div>
            <span class="tag">{{natureOfBusiness?.mainActivityCodeShare}} %</span>
          </div>
          <div class="activity-code__line">
            <span class="tag">{{mainBusinessActivity?.code}}</span>
            <span class="section-value">{{mainBusinessActivity?.name}}</span>
          </div>
        </div>
      </div>
    </div>

    <div nz-row class="section-row">
      <div nz-col nzSpan="11" class="section-label">
        Other
      </div>
      <div nz-col nzSpan="13">
        <ng-container *ngIf="otherBusinessActivities.length > 0">
          <div class="activity-code" *ngFor="let item of otherBusinessActivities; let last = last" [ngStyle]="{'padding-bottom': !last ? '16px' : '0'}">
            <div>
              <span class="tag">{{item?.share}} %</span>
            </div>
            <div class="activity-code__line">
              <span class="tag">{{item?.data?.code}}</span>
              <span class="section-value">{{item?.data?.name}}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="otherBusinessActivities.length == 0">

          <div nz-row [ngStyle]="{'padding-bottom': '8px'}">
            <div nz-col nzSpan="15">
              <span class="section-value">
                -
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-container>
  <div class="section-header">
    <span>Company Details</span>
  </div>
  <div class="section-wrapper">

    <div nz-row class="section-row section-row--dashed" *ngIf="natureOfBusiness?.foundationAifcPurposes && isFou()">
      <div nz-col nzSpan="11" class="section-label">
        Please specify the purpose of the Foundation to be established in the AIFC
      </div>
      <div nz-col nzSpan="13">
        <ng-container *ngFor="let item of natureOfBusiness?.foundationAifcPurposes">
          <span class="section-value">
            {{item}} <br>
          </span>
        </ng-container>
      </div>
    </div>

    <div nz-row class="section-row section-row--dashed">
      <div nz-col nzSpan="11" class="section-label">
        Type of Legal Entity
      </div>
      <div nz-col nzSpan="13">
        <span class="section-value">
          {{natureOfBusiness?.legalEntityType == 'COMMERCIAL' ? 'Commercial' : 'Non-Commercial'}}
        </span>
      </div>
    </div>

    <div nz-row class="section-row section-row--dashed" *ngIf="natureOfBusiness?.legalEntityType == 'COMMERCIAL' && businessSizeText != ''">
      <div nz-col nzSpan="11" class="section-label">
        Expected size of business
      </div>
      <div nz-col nzSpan="13">
        <span class="section-value">
          {{businessSizeText}}
        </span>
      </div>
    </div>

    <div nz-row class="section-row section-row--dashed">
      <div nz-col nzSpan="11" class="section-label">
        Expected number of employees
      </div>
      <div nz-col nzSpan="13">
        <span class="section-value">
          {{natureOfBusiness?.employeeNumber}}
        </span>
      </div>
    </div>

    <div nz-row class="section-row section-row--dashed">
      <div nz-col nzSpan="11" class="section-label">
        Is a legal entity a Value Added Tax (VAT) payer?
      </div>
      <div nz-col nzSpan="13">
        <span class="section-value">
          {{natureOfBusiness?.isTaxPayer ? 'Yes' : 'No'}}
        </span>
      </div>
    </div>

    <div nz-row class="section-row">
      <div nz-col nzSpan="11" class="section-label">
        Financial year end
      </div>
      <div nz-col nzSpan="13">
        <span class="section-value">
          {{financialYearEndText}}
        </span>
      </div>
    </div>
  </div>
</ng-container>
